(function(angular){
    'use strict';

    angular.module('onvio.setup').controller('TermsSetupCtrl', termsSetup);
    termsSetup.$inject = ['$timeout', '$q', '$uibModal', '$translate', 'TermsSetupManager', 'bluemoon.components.Notifications', 'bmFroalaTranslate'];

    function termsSetup($timeout, $q, $uibModal, $translate, TermsSetupManager, Notifications, froalaTranslate){
        /*jshint validthis:true */
        this.$onInit = function() {
            var vm = this;
            vm.languageLocal = vm.data;
            vm.language = vm.data.code;
            vm.toggleState = false;
            vm.onToggleChange = onToggleChange;
            vm.toggleSwitch = toggleSwitch;
            vm.openSampleTermsModal = openSampleTermsModal;
            vm.openPublishedTermsModal = openPublishedTermsModal;
            vm.publishTerms = publishTerms;
            vm.saveDraft = saveDraft;
            vm.discardDraft = discardDraft;
            vm.froalaContentUpdated = froalaContentUpdated;

            // Create method publicly available through 2-way data bound object
            vm.languageLocal.saveChanges = function(){
                if(vm.isDirtyText){
                    return vm.saveDraft(false);
                }

                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            };

            // Setup options for wysiwyg
            vm.froalaOptions = {
                buttons: [
                    'bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'sep', 'formatBlock', 'align', 'insertUnorderedList', 'insertOrderedList', 'indent', 'outdent', 'sep', 'createLink', 'insertHorizontalRule', 'undo', 'redo', 'html'
                ],
                height: 300,
                tabSpaces: false,
                pasteImage: false,
                imageUpload: false
            };

            var latestPublishedTerms;
            var latestDraftTerms;

            $translate('Onvio.Setup.Terms.Form.EnableTooltip').then(function(value){
                vm.tooltipText = value;
            });

            froalaTranslate.getLoadedLanguageAsync().then(function(languageCode){
                vm.froalaOptions.language = languageCode;
            });

            TermsSetupManager.loadTermsAsync(vm.language).then(function(termsList){
                setLatestTerms(termsList);
            }, function(){
                $translate('Onvio.Setup.Terms.Load.Error').then(function(value){
                    Notifications.setError(value);
                });
            });

            //////////

            function setLatestTerms(termsList){
                if(angular.isUndefined(termsList) || termsList.length === 0){
                    vm.isDirtyText = false;
                    return;
                }

                var current;

                for(var index = 0; index < termsList.length; index++){
                    current = termsList[index];

                    if(angular.isDefined(current.publishDate) && current.publishDate !== ''){
                        // Set published version to most recent
                        if(angular.isUndefined(latestPublishedTerms) || latestPublishedTerms.version < current.version){
                            latestPublishedTerms = current;
                            vm.publishedText = latestPublishedTerms.text;
                            vm.versionNumber = latestPublishedTerms.version;
                            vm.toggleState = latestPublishedTerms.active;
                        }
                    } else {
                        // There should only ever be 1 set of terms that is the current draft
                        latestDraftTerms = current;
                        vm.draftText = latestDraftTerms.text;
                    }
                }

                if(angular.isDefined(vm.draftText)){
                    vm.initialText =  vm.draftText;
                    vm.isDirtyText = true;
                } else {
                    vm.initialText = vm.publishedText;
                }

                vm.newText = vm.initialText;
            }

            function publishTerms(){
                resetNotifications();

                // make sure to grab latest html for sure
                vm.newText = getFroalaHtml();

                var publishedDate = new Date();
                var termsToPublish = {
                    text: vm.newText,
                    active: vm.toggleState,
                    locale: vm.language,
                    publishDate: publishedDate.toISOString()
                };

                // This is an update to the current draft if one exists
                termsToPublish.id = angular.isDefined(latestDraftTerms) && angular.isDefined(latestDraftTerms.id) ? latestDraftTerms.id : undefined;

                TermsSetupManager.saveTermsAsync(vm.language, termsToPublish).then(function(result){
                    // Save local copy
                    latestPublishedTerms = result;

                    // Set view states
                    vm.versionNumber = latestPublishedTerms.version;
                    vm.publishedText = vm.newText;
                    vm.draftText = undefined;
                    vm.isDirtyText = false;
                    vm.initialText = vm.newText;
                    $translate('Onvio.Setup.Terms.Publish.Success').then(function(value){
                        Notifications.setInfo(value);
                    });
                });
            }

            function saveDraft(displayNotification){
                // TODO: WILL NEED TO CHANGE TO SAVE HTML
                resetNotifications();

                var draftToSave = angular.isDefined(latestDraftTerms) ? latestDraftTerms : { locale: vm.language, active: false };

                // make sure to grab latest html for sure
                vm.newText = getFroalaHtml();
                draftToSave.text = vm.newText;

                if(draftToSave.text === ''){
                    // never had a draft and there's nothing to save
                    if(angular.isUndefined(draftToSave.id)){
                        resetViewForDiscard();
                        var deferred = $q.defer();
                        deferred.resolve();
                        return deferred.promise;
                    }

                    // killing off current draft
                    return TermsSetupManager.deleteTermsAsync(draftToSave.locale, draftToSave.id).then(function(){
                        resetViewForDiscard();
                    });
                }

                return TermsSetupManager.saveTermsAsync(vm.language, draftToSave).then(function(result){
                    latestDraftTerms = result;
                    vm.draftText = vm.newText;
                    $translate('Onvio.Setup.Terms.Draft.Success').then(function(value){
                        if(displayNotification){
                            Notifications.setInfo(value);
                        }
                    });
                });
            }

            function discardDraft(){
                resetNotifications();

                // Revert to latest published and wipe any user entry
                if(angular.isDefined(latestDraftTerms) && angular.isDefined(latestDraftTerms.id)){
                    TermsSetupManager.deleteTermsAsync(vm.language, latestDraftTerms.id).then(function(){
                        resetViewForDiscard();
                    });
                } else {
                    resetViewForDiscard();
                }
            }

            function resetViewForDiscard(){
                latestDraftTerms = undefined;
                vm.draftText = undefined;
                vm.initialText = vm.publishedText;
                vm.newText = vm.initialText;
                vm.isDirtyText = false;
            }

            // accessing toggle button using space key
            function toggleSwitch(event, value) {
                if (event.which === 32) {
                    onToggleChange(value);
                }
            }

           function onToggleChange(value){
                if(value) {
                    openEnableConfirmModal();
                    return;
            }

            // Set latest published version as inactive
            latestPublishedTerms.active = false;

            TermsSetupManager.saveTermsAsync(vm.language, latestPublishedTerms).then(function(){
                $translate('Onvio.Setup.Terms.Form.DisableMessage').then(function(translation){
                    Notifications.setInfo(translation);
                });
            }, function(){
                // Set latest back to active for failed request
                latestPublishedTerms.active = true;
                vm.toggleState = true;
            });
            }

            function openSampleTermsModal(){
                TermsSetupManager.loadSampleTextAsync(vm.language).then(function(text){
                    var modalInstance = $uibModal.open({
                        templateUrl: 'setup/src/terms/terms-setup/sample-terms/sample-terms-modal.2js.html',
                        controller: 'SampleTermsModalCtrl as vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            text: function() {
                                return text;
                            }
                        }
                    });

                    modalInstance.result.then(function(sampleText){
                        if(angular.isDefined(sampleText) && sampleText !== ''){
                            vm.isDirtyText = true;
                            vm.newText = sampleText;
                        }
                    });
                });
            }

            function openEnableConfirmModal(){
                var modalInstance = $uibModal.open({
                    templateUrl: 'setup/src/terms/terms-setup/enable-terms/terms-enable-confirm-modal.2js.html',
                    controller: 'EnableTermsConfirmModalCtrl as vm',
                    backdrop: 'static'
                });

                modalInstance.result.then(function(isConfirmed){
                    // Set latest published version to active
                    if(isConfirmed){
                        latestPublishedTerms.active = true;
                        TermsSetupManager.saveTermsAsync(vm.language, latestPublishedTerms).then(function(){
                            vm.toggleState = true;
                        }, function(){
                            vm.toggleState = false;
                        });
                    } else {
                        vm.toggleState = false;
                    }
                });
            }

            function openPublishedTermsModal(){
                $uibModal.open({
                    templateUrl: 'setup/src/terms/terms-setup/published-terms/published-terms-modal.2js.html',
                    controller: 'PublishedTermsModalCtrl as vm',
                    backdrop: 'static',
                    resolve: {
                        publishedTerms: function(){
                            return latestPublishedTerms;
                        }
                    }
                });
            }

            function resetNotifications(){
                Notifications.setError(null);
                Notifications.setInfo(null);
            }

            function froalaContentUpdated(){
                // need to give froala time to update the model for pasted text and typing
                $timeout(function(){
                    setDirtyText();
                }, 1000);
            }

            function setDirtyText(){
                if(angular.isDefined(vm.draftText)){
                    vm.isDirtyText = true;
                } else {
                    // pull html from froala directly as model not necessarily updated on minor changes
                    var froalaHtml = getFroalaHtml();

                    // handle the case where there is no text or the text is cleared
                    if((angular.isUndefined(vm.initialText) || vm.initialText === '') && (angular.isUndefined(froalaHtml) || froalaHtml === '')){
                        vm.isDirtyText = false;
                    } else {
                        vm.isDirtyText = vm.initialText !== froalaHtml;
                    }
                }
            }

            function getFroalaHtml(){
                return vm.froalaOptions.froala('getHTML');
            }
        };
    }
})(window.angular);
